import { render } from "./FourOhFour.vue?vue&type=template&id=6cc81c16&scoped=true"
import script from "./FourOhFour.vue?vue&type=script&lang=js"
export * from "./FourOhFour.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc81c16"]])

export default __exports__